const TAG_BUSINESS_STATES = {
  AVAILABLE: 'AVAILABLE',
  PAIRED: 'PAIRED'
};
const TAG_RING_COMMAND_STATES = {
  WAITING_FOR_DETECTION: 'waitingForDetection',
  SENT_TO_GATEWAY_DEVICE: 'sentToGatewayDevice',
  DELIVERED: 'delivered',
  FAILED: 'failed',
  CANCELLED: 'cancelled'
};
const RINGING_DURATION_MS = 40 * 1000;
const RINGING_COMMAND_COOLDOWN_MS = 35 * 1000;
const WAITING_FOR_DETECTION_MAX_DURATION_MS = 120 * 1000;
const WAITING_FOR_RESPONSE_MAX_DURATION_MS = 90 * 1000;
export default {
  TAG_BUSINESS_STATES,
  TAG_RING_COMMAND_STATES,
  RINGING_DURATION_MS,
  RINGING_COMMAND_COOLDOWN_MS,
  WAITING_FOR_DETECTION_MAX_DURATION_MS,
  WAITING_FOR_RESPONSE_MAX_DURATION_MS
};